angular.module('wbDashboard').controller('RecoverControllerAurea', ['$scope', 'Login', 'Misc', '$uibModal', function ($scope, Login, Misc, $uibModal) {

    $scope.pageData = {
        sending : false,
        status : null,
        errorMessage : null,
        success : false
    };

    $scope.forms = {};
    $scope.recover = {};
    $scope.update = {};

    $scope.validation = Misc.validation;

    /**
     * Send email with username
     */
    $scope.recoverUsernameSubmit = function() {
        $scope.pageData.errorMessage = null;
        $scope.pageData.sending = true;

        Login.forgotUsername($scope.recover.email).then(function () {
            $scope.pageData.errorMessage = null;
            $scope.pageData.success = true;
        }).catch(function () {
            $scope.pageData.errorMessage = "Something went wrong with your request; please email support@axosinvest.com";
        }).finally(function() {
            $scope.pageData.sending = false;
        });
    };

    /**
     * Send email with password recovery link
     */
    $scope.recoverPasswordSubmit = function() {
        $scope.pageData.errorMessage = null;
        $scope.pageData.sending = true;

        Login.forgotPassword($scope.recover.email).then(function () {
            $scope.pageData.errorMessage = null;
            $scope.pageData.success = true;
        }).catch(function () {
            $scope.pageData.errorMessage = "Something went wrong with your request; please email support@axosinvest.com";
        }).finally(function() {
            $scope.pageData.sending = false;
        });
    };

    /**
     * Reset either username or password email request forms
     */
    $scope.recoverReset = function() {
        $scope.pageData.errorMessage = null;
        $scope.pageData.success = false;
        $scope.recover = {};
        $scope.forms.recover.$setPristine(true);
    };

    /**
     * Submit new password from recovery link
     */
    $scope.updatePasswordSubmit = function() {
        $scope.pageData.errorMessage = null;
        $scope.pageData.sending = true;

        $scope.update.token = $scope.$stateParams.resetToken;

        Login.reset($scope.update).then(function () {
            $scope.pageData.success = true;
        }).catch(function (response) {
            if (response.data) {
                if (response.data.message) {
                    $scope.pageData.errorMessage = response.data.message;
                } else if (response.data.error && response.data.error.message) {
                    $scope.pageData.errorMessage = response.data.error.message;
                } else {
                    $scope.pageData.errorMessage = "Something went wrong with your request; please email support@axosinvest.com";
                }
            } else {
                $scope.pageData.errorMessage = "Something went wrong with your request; please email support@axosinvest.com";
                throw response;
            }
        }).finally(function() {
            $scope.pageData.sending = false;
        });
    };


}]);
